exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result-courses[data-v-f261ba84]{background-color:#ededed;padding:10px}.result-courses_item[data-v-f261ba84]{display:-ms-grid;display:grid;gap:1em;margin:10px;padding:10px;background:#fff;border-radius:12px;-ms-grid-columns:1fr 2fr;grid-template-columns:1fr 2fr}@media only screen and (max-width:40em){.result-courses_item[data-v-f261ba84]{-ms-grid-columns:unset;grid-template-columns:unset}}.result-courses_item .image-box[data-v-f261ba84]{width:100%;margin-right:10px}.result-courses_item .image-box_picture[data-v-f261ba84]{width:100%;height:auto;object-fit:contain}@media only screen and (min-width:40em) and (max-width:64.063em){.result-courses_item .info-box[data-v-f261ba84]{max-width:70%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f261ba84","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/resultCourses/ResultCourses.vue
// module id = 93142200df328f8bcaf2
// module chunks = 23